import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { bootstrapApi } from './api/bootstrap';
import { createApiErrorHandler } from './api/handleApiError';
import { createQueryClient } from './api/queryClient';
import { parseEnv, setEnv } from './env';
import './index.css';
import { router } from './routes';
import { useAuthStore } from './stores/authStore';
import { syncAuthStoreWithTokenStorage } from './stores/authPersistence';

async function boot() {
  // 1) Validar env. Lanza con error claro si algo falta.
  const env = parseEnv(import.meta.env as Record<string, unknown>);
  setEnv(env);

  // 2) Inicializar singletons del api-client.
  const api = bootstrapApi();

  // 3) Hidratar authStore desde TokenStorage y suscribirse a cambios.
  await syncAuthStoreWithTokenStorage(api.tokenStorage, window.localStorage);

  // 4) Crear el QueryClient con el handler global de 401.
  const apiErrorHandler = createApiErrorHandler({
    tokenStorage: api.tokenStorage,
    resetAuth: () => {
      useAuthStore.getState().reset();
    },
  });
  const queryClient = createQueryClient(apiErrorHandler);

  // 5) Mount.
  const rootEl = document.getElementById('root');
  if (!rootEl) {
    throw new Error('#root element not found in index.html');
  }
  createRoot(rootEl).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </StrictMode>,
  );
}

void boot();
